import React from 'react';
import Typography from '@mui/material/Typography';

interface ErrorTypographyProps {
  message: string;
}

export const ErrorTypography: React.FC<ErrorTypographyProps> = ({
  message,
}) => {
  return (
    <Typography color="red" component="div">
      {message}
    </Typography>
  );
};
